export const ACTIVITY_FILTERS = [
  { label: "Title", value: "title" },
  { label: "Keywords", value: "keywords" },
  { label: "Description", value: "description" },
];

export const FILTERS = "streamingFilters";
